import React from "react";
import { FormattedMessage } from "react-intl";
import {
  hotelBirthdayPromoConfig,
  isHotelBirthdayPromoActive,
} from "../../../common/util/hotelBirthdayPromo";
import { Button } from "../../atoms";
import { CartTotalBtnWrapper } from "./Cart.style";

const partnerId = process.env.REACT_APP_SITE_ID || "";

interface ICartTotalBtnProps {
  submit?: () => void;
  finalPrice: number;
  loading: boolean;
  checkInCheckOut: string;
  onRequest: boolean;
}
export const CartHotelTotalBtn: React.FC<ICartTotalBtnProps> = ({
  submit,
  finalPrice,
  loading,
  checkInCheckOut,
  onRequest,
}) => {
  const showBirthdayPromo = isHotelBirthdayPromoActive({ partnerId });

  return (
    <CartTotalBtnWrapper>
      <div className="cart-total-date">{checkInCheckOut}</div>
      <div className="cart-total-total">
        <span>
          {" "}
          <FormattedMessage
            description="Total"
            defaultMessage="Total"
            id="XmkR3j"
          />
        </span>
        <span className="cart-total-total-price">€{finalPrice}</span>
      </div>
      {onRequest && (
        <div
          style={{
            textAlign: "center",
            padding: "10px 20px",
            fontSize: 12,
            color: "red",
          }}
        >
          On Request: Το συγκεριμένο δωμάτιο δεν παρέχει άμεση διαδικτυακή
          επιβεβαίωση για τις συγκεκριμένες ημερομηνίες. Μπορείτε να μας
          στείλετε το αίτημα σας χωρίς καμία δέσμευση επιλέγοντας την On Request
          προσφορά.
        </div>
      )}
      {submit && (
        <div className="cart-total-button-wrap">
          <Button className="cart-total-btn" onClick={submit} loading={loading}>
            {" "}
            {onRequest ? (
              "Αίτημα κράτησης"
            ) : (
              <FormattedMessage
                description="Book Now"
                defaultMessage="Book Now"
                id="1ZQWdS"
              />
            )}
          </Button>
          {showBirthdayPromo && (
            <img
              className="cart-total-promo-image"
              src={hotelBirthdayPromoConfig.imagePath}
              alt="Birthday Offer -9%"
            />
          )}
        </div>
      )}
    </CartTotalBtnWrapper>
  );
};
